var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b67407d7b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 22.5 L 150 22.5 L 150 127.5 L 0 127.5 Z M 0 22.5 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 61.40625 43.449219 C 60.910156 42.953125 60.160156 42.953125 59.414062 43.449219 C 58.914062 43.699219 58.414062 44.449219 58.414062 45.195312 L 58.414062 99.566406 C 58.414062 100.316406 58.914062 100.8125 59.414062 101.3125 C 59.660156 101.5625 59.910156 101.5625 60.410156 101.5625 C 60.660156 101.5625 61.15625 101.5625 61.40625 101.3125 L 102.808594 74.128906 C 103.308594 73.878906 103.558594 73.128906 103.558594 72.628906 C 103.558594 72.132812 103.308594 71.382812 102.808594 71.132812 Z M 62.15625 96.074219 L 62.15625 48.6875 L 98.320312 72.382812 Z M 62.15625 96.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b67407d7b1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 125.503906 22.5 L 24.246094 22.5 C 11.277344 22.5 0.800781 32.976562 0.800781 45.945312 L 0.800781 104.054688 C 0.800781 117.023438 11.277344 127.5 24.246094 127.5 L 125.753906 127.5 C 138.722656 127.5 149.199219 117.023438 149.199219 104.054688 L 149.199219 46.195312 C 149.199219 33.222656 138.472656 22.5 125.503906 22.5 Z M 145.207031 104.054688 C 145.207031 115.03125 136.230469 123.757812 125.503906 123.757812 L 24.246094 123.757812 C 13.273438 123.757812 4.542969 114.78125 4.542969 104.054688 L 4.542969 46.195312 C 4.542969 35.21875 13.519531 26.492188 24.246094 26.492188 L 125.753906 26.492188 C 136.726562 26.492188 145.457031 35.46875 145.457031 46.195312 L 145.457031 104.054688 Z M 145.207031 104.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1a5b91397069ea04409fd8b2997c1a86.svg";
export { ForwardRef as ReactComponent };